// src/components/CampaignWizard/SummarySidebar.tsx
import React from "react";
import { Card, Badge } from "reactstrap";

export interface SummaryItem {
	icon: string;     // remix icon class
	title: string;
	detail: React.ReactNode;
	badgeColor?: string;
	badgeText?: string | number;
}

export interface SummarySidebarProps {
	items: SummaryItem[];
	topOffset?: number; // in px, defaults to 80
}

const SummarySidebar: React.FC<SummarySidebarProps> = ({
	items,
	topOffset = 80,
}) => (
	<Card
		className="sticky-top shadow-sm border rounded-4 p-4 bg-light-subtle"
		style={{ top: topOffset }}
	>
		<h6 className="fw-bold text-secondary mb-4 border-bottom pb-2">
			Summary
		</h6>
		{items.map((it, idx) => (
			<div key={idx} className="mb-4 d-flex align-items-start">
				<div
					className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center me-3"
					style={{ width: 36, height: 36 }}
				>
					<i className={`${it.icon} fs-5`} />
				</div>
				<div className="flex-grow-1">
					<small className="text-muted d-block">{it.title}</small>
					<div className="fw-semibold">
						{it.detail}
						{it.badgeText != null && (
							<Badge
								color={it.badgeColor || "primary"}
								pill
								className="ms-2"
							>
								{it.badgeText}
							</Badge>
						)}
					</div>
				</div>
			</div>
		))}
	</Card>
);

export default SummarySidebar;
